export default __webpack_public_path__ + "static/media/ic_glp_40.cb1ab28b.svg";